<template>
    <main class="c-app-content is-sidebar-tiny">
        <g-loading v-if="firstLoading" />
        <div v-else >
            <div class="card title">
                <div class="card-body title-filter">
                    <div class="row">
                        <div class="col-lg-4 title-filte-left mb-1">
                            <h1 class="title-filter-title">
                                <i class="fa fa-file-alt"></i>
                                <p class="pl-1">Dữ liệu kiểm toán rác</p>
                            </h1>
                        </div>

                        <div class="col-lg-8 title-filte-right">
                            <form-select :model="filterFormModel" class="mr-1 col-md-3" attribute="year"  :options="years" :isFilter="true" @change="search" />
                            <ward-select :model="filterFormModel" class="mr-1 col-md-3" attribute="ward_id" :multiple="false" :close-on-select='true' :filter="{did: 509}" @change="search" />
                            <g-button v-if="permissions('data-greenhub_create')" :loading="saveLoading" size="sm" variant="success" icon="fa fa-plus" content="Thêm mới"  @click="create" />
                            <button class="btn btn-gray btn-sm mr-1 ml-1" @click="reset">
                                <b-spinner v-if="listLoading" small></b-spinner>
                                <i v-else class="fa fa-sync-alt" ></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card title">
                <div class="card-body title-body pb-2 pl-2 pr-2">
                    <div class="tile-title is-line">
                        <div class="text-black size-14">
                            Danh sách
                            <span v-if="itemCount"> {{itemCount|numFormat}} </span> 
                            <span class="text-lowercase">dữ liệu</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 title-template-table table-responsive">
                            <g-loading v-if="firstLoading" />
                            <div v-else-if="listLoading" class="text-center text-primary">
                                <b-spinner></b-spinner>
                            </div>
                            <div v-else-if="!listLoading && !itemCount" class="text-center text-danger">
                                Không tìm thấy thông tin dữ liệu!
                                <br/> 
                                Click <a href='javascript:;' v-if="permissions('data-greenhub_create')"  @click="create">vào đây</a> để thêm mới
                            </div>
                            <table v-else class="table b-table table table-hover table-head-fixed table-striped table-hover table-bordered">
                                <thead>
                                    <tr>
                                        <th rowspan="2" class="text-center" >Phường</th>
                                        <th rowspan="2" class="text-center" >Năm</th>
                                        <th class="text-center" v-for="field in fields" :key="field.key" colspan="2" >{{field.label}}</th>
                                        <th rowspan="2" class="text-right">Hành động</th>
                                    </tr>
                                    <tr>
                                <template v-for="field in fields">
                                    <th :key="`sl-${field.key}`" class="text-center">Ngày dễ</th>
                                    <th :key="`kl-${field.key}`" class="text-center">Ngày khó</th>
                                </template>

                                </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in items" :key="item.id" >
                                        <td>
                                            <div v-if="item.ward_id && params.locations && params.locations[item.ward_id]">{{params.locations[item.ward_id].name}}</div>
                                        </td> 
                                        <td class="text-center">{{item.year}}</td>
                                <template v-for="field in fields">
                                    <td :key="`sl-${field.key}`" class="text-center">
                                        <div v-if='params.custom_fields && params.custom_fields[item.id] && params.custom_fields[item.id][field.key] && params.custom_fields[item.id][field.key].easy'>{{params.custom_fields[item.id][field.key].easy}}</div>
                                    </td>
                                    <td :key="`kl-${field.key}`" class="text-center">
                                        <div v-if='params.custom_fields && params.custom_fields[item.id] && params.custom_fields[item.id][field.key] && params.custom_fields[item.id][field.key].hard'>{{params.custom_fields[item.id][field.key].hard}}</div>
                                    </td>
                                </template>
                                <td class="text-right">
                                <g-button v-if="permissions('data-greenhub_update')" :loading="updateLoading" size="sm" variant="outline-info" class="ml-1 mb-1" icon="pencil" @click="update(item.id)"  />
                                <g-button  v-if="permissions('data-greenhub_del')" :loading="delLoading" size="sm" variant="outline-danger" class="ml-1 mb-1"   icon="trash-fill" @click='del(item.id)' />
                                </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <b-modal v-model="showForm" size="lg" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
            <ward-select label="Phường"  :required='true'  :model="formModel" attribute="ward_id" :multiple="false" :errors="formErrors" :close-on-select='true' :filter="{did: 509}" />
            <form-input :disabled="formModel.id"  label="Năm kiểm toán" :required='true' :model="formModel" attribute="year" :errors="formErrors" type="number"/>
            <form-custom-fields :model="formModel" :errors="formErrors" :disabledTitle=true :custom-fields="params.fields" />
            <template v-slot:modal-footer="{ ok, cancel}">
                <b-button variant="secondary" class="float-right" @click="cancel">Đóng</b-button>
                <b-button :disabled="saveLoading" variant="primary" class="float-right" @click="ok">
                    <b-spinner v-if="saveLoading" small></b-spinner>
                    <em v-else class="fa fa-save" ></em>
                    Lưu lại
                </b-button>
            </template>
        </b-modal>
    </main>
</template>

<script>
    import list from "@/mixins/List";
    import crud from '@/mixins/CRUD';
    import FormCustomFields from './FormCustomFields';
    import role from '@/mixins/Role';
    import WardSelect from '@/components/WardSelect';

    export default {
        components: {FormCustomFields, WardSelect},
        mixins: [list, crud, role],
        data: function () {
            return {
                reloadBus: "reloadDataGreenhub",
                service: '/data-greenhub',
                fields: [],
                years: this.getYears(),
                defaultFilterFormModel: {
                    keyword: '',
                    year: null,
                    ward_id: null,
                },
                defaultFormModel: {
                    ward_id: null,
                },
                filter: {ward_id: -9999, blocked: '1'},
            }
        },
        watch: {
            "formModel.name": {
                handler(val) {
                    if (val && (!this.formModel.id || !this.formModel.slug)) {
                        this.formModel.slug = this.$utils.createCode(val);
                    }
                }, deep: true
            },
            "formModel.slug": {
                handler(val) {
                    if (val) {
                        this.formModel.slug = this.$utils.createCode(val);
                    }
                }, deep: true
            },
        },
        methods: {
            beforeLoad() {
                this.fields = [];
                if (this.params.fields && this.params.fields.length) {
                    for (let field of this.params.fields) {
                        field.inputType = 'number';
                        if (!field.show_in_list || field.blocked) {
                            continue;
                        }
                        this.fields.push(field);
                    }
                }
            },
            getYears() {
                let years = [];
                years.push({value: null, text: "Năm khai thác: Toàn bộ"});
                for (let i = 1990; i < 2300; i++) {
                    years.push({value: i, text: i});
                }
                return years;
            },
        },
        mounted() {
        }
    }
</script>